import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateRefund, updateRefund } from "./update-refund";
import type { UpdateState } from "src/redux/state/shared-types";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateRefundReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateRefund.fulfilled, (state, { meta }) => {
    return {
      ...state,
      justUpdatedId: meta.arg.id,
      processing: "success",
    };
  });
  builder.addCase(updateRefund.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateRefund.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateRefund, () => {
    return initialState;
  });
});
